// Voice editor — 3. Phrases section. Extracted verbatim from
// `VoiceEditorPage.tsx` (no behavior change).

import { useT } from '@barel/i18n';
import { FieldAssembly } from '@barel/ui';

import { PhraseListEditor } from '../components/PhraseListEditor';
import { SectionShell, type SectionPropsWithVoice } from './SectionShell';

export function PhrasesSection({ voice, flush }: SectionPropsWithVoice) {
  const t = useT('voice');
  return (
    <SectionShell title={t('phrases.title')} subtitle={t('phrases.subtitle')}>
      <div className="flex flex-col gap-4">
        <FieldAssembly
          label={t('phrases.bannedTitle')}
          description={t('phrases.bannedSub')}
          hint={t('phrases.bannedHint')}
          asChild
        >
          <div role="group" aria-label={t('phrases.bannedTitle')}>
            <PhraseListEditor
              value={voice.banned}
              onChange={(next) => {
                void flush({ banned: next });
              }}
              placeholder={t('phrases.bannedPlaceholder')}
              addCta={t('phrases.bannedAdd')}
              ariaLabel={t('phrases.bannedTitle')}
              removeAriaLabel={(tag) => t('phrases.bannedRemove', { tag })}
              accent="banned"
              testId="voice-banned-list"
            />
          </div>
        </FieldAssembly>
        <FieldAssembly
          label={t('phrases.signatureTitle')}
          description={t('phrases.signatureSub')}
          hint={t('phrases.signatureHint')}
          asChild
        >
          <div role="group" aria-label={t('phrases.signatureTitle')}>
            <PhraseListEditor
              value={voice.signature}
              onChange={(next) => {
                void flush({ signature: next });
              }}
              placeholder={t('phrases.signaturePlaceholder')}
              addCta={t('phrases.signatureAdd')}
              ariaLabel={t('phrases.signatureTitle')}
              removeAriaLabel={(tag) => t('phrases.signatureRemove', { tag })}
              accent="signature"
              testId="voice-signature-list"
            />
          </div>
        </FieldAssembly>
      </div>
    </SectionShell>
  );
}
